import { useEffect, useRef, useState } from "react";

// Coherent-signal motif: an irregular amber line becomes organized through
// blue/cyan nodes and resolves into a precise engineered structure. Animates
// once on entering the viewport; respects prefers-reduced-motion via CSS.
export function SignalMotif({ className = "", height = 120 }) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setActive(true);
          obs.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return (
    <div ref={ref} className={`${active ? "signal-animate" : ""} ${className}`} aria-hidden="true">
      <svg viewBox="0 0 1200 120" width="100%" height={height} preserveAspectRatio="none">
        <path
          className="signal-path"
          d="M0,80 C60,80 80,30 120,70 C160,110 190,20 240,75 C300,95 340,45 400,60 L520,60 L640,60 L760,60 L900,60 L1050,60 L1200,60"
          fill="none"
          stroke="#F3B75B"
          strokeWidth="2"
        />
        <path
          d="M400,60 L1200,60"
          fill="none"
          stroke="#2867B2"
          strokeWidth="2"
          className="signal-path"
          style={{ animationDelay: "0.6s" }}
        />
        {[400, 520, 640, 760, 900, 1050].map((cx, i) => (
          <circle
            key={cx}
            className="signal-node"
            cx={cx}
            cy="60"
            r={i === 0 ? 5 : 4}
            fill={i < 2 ? "#58BFD2" : "#2867B2"}
            style={{ animationDelay: `${1 + i * 0.12}s` }}
          />
        ))}
        <rect className="signal-node" x="1180" y="52" width="16" height="16" fill="#10253F" style={{ animationDelay: "1.9s" }} />
      </svg>
    </div>
  );
}
